import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon.js';
import styles from './Note.module.scss.js';

var Note = function Note(_ref) {
  var title = _ref.title,
    text = _ref.text,
    secondaryText = _ref.secondaryText;
  return /*#__PURE__*/React.createElement("section", {
    className: styles.infoBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.infoContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-info",
    size: "medium",
    className: styles.icon
  }), /*#__PURE__*/React.createElement("h3", {
    className: styles.iconText
  }, title, " ")), /*#__PURE__*/React.createElement("p", {
    className: styles.infoText
  }, text), /*#__PURE__*/React.createElement("p", {
    className: styles.infoText
  }, secondaryText));
};
Note.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  secondaryText: PropTypes.string
};
Note.defaultProps = {
  secondaryText: ''
};

export { Note as default };
